import { render, staticRenderFns } from "./UnderlyingDetails.vue?vue&type=template&id=4196e940&"
import script from "./UnderlyingDetails.vue?vue&type=script&lang=js&"
export * from "./UnderlyingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports